import { render, staticRenderFns } from "./VersionTable.vue?vue&type=template&id=63f47f20&scoped=true&"
import script from "./VersionTable.vue?vue&type=script&lang=js&"
export * from "./VersionTable.vue?vue&type=script&lang=js&"
import style0 from "./VersionTable.vue?vue&type=style&index=0&id=63f47f20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f47f20",
  null
  
)

export default component.exports